import { KLAGE_ILEGGELSE_THUMBNAIL_IMAGE } from "../actions/klager/klageAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const INITIAL_STATE = [];

const klageIleggelseThumbnailImageReducer = (
  state = INITIAL_STATE,
  action
) => CreateNewReducer(state, action, KLAGE_ILEGGELSE_THUMBNAIL_IMAGE);

export default klageIleggelseThumbnailImageReducer;
